export default "__VITE_ASSET__DNkb0AV0__"